import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-icon_zoom_out",
  "use": "icon-icon_zoom_out-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-icon_zoom_out\"><defs><style></style></defs><path d=\"M716.8 440.934a25.6 25.6 0 0 0-25.6-25.6H191.693a25.6 25.6 0 0 0 0 51.2H690.38a25.6 25.6 0 0 0 26.419-25.6z\" /><path d=\"M998.605 962.56L757.76 721.1a424.346 424.346 0 1 0-36.66 36.66l241.46 240.845a25.6 25.6 0 0 0 36.045-36.045zM177.97 703.898A371.917 371.917 0 1 1 440.934 812.85a372.326 372.326 0 0 1-262.963-108.953z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol